import type { PropsWithChildren } from 'react';
import { AuthProvider } from '@/app/contexts/AuthContext';
import { GuildActivityFeedProvider } from '@/app/contexts/GuildActivityFeedContext';
import { GuildChatProvider } from '@/app/contexts/GuildChatContext';
import { GuildDataProvider } from '@/app/contexts/GuildDataContext';
import { MassNotificationsProvider } from '@/app/contexts/MassNotificationsContext';
import { PlayerSheetProvider } from '@/app/contexts/PlayerSheetContext';
import { MassNotificationViewport } from '@/components/notifications/MassNotificationViewport';

export function AppProviders({ children }: PropsWithChildren): JSX.Element {
  return (
    <AuthProvider>
      <GuildDataProvider>
        <PlayerSheetProvider>
          <GuildActivityFeedProvider>
            <GuildChatProvider>
              <MassNotificationsProvider>
                {children}
                <MassNotificationViewport />
              </MassNotificationsProvider>
            </GuildChatProvider>
          </GuildActivityFeedProvider>
        </PlayerSheetProvider>
      </GuildDataProvider>
    </AuthProvider>
  );
}
